<template>
    <div class="schdule-contain">
        <div class="header">
            <div class="Table">
                <div class="Heading-Year">
                    <div class="Cell" style="width:60px;"></div>
                    <div class="Cell Year"  v-for="(item,index) in monthDisplay" :key="index"><span v-if="index==0 || item.month==0">{{item.year}}</span></div>
                    <div class="Cell" style="width:60px;"></div>
                </div>
                <div class="Row" ref="grid-month">
                    <div class="Cell" style="width:60px;">
                        <md-button class="md-icon-button" @click="previous()">
                            <md-icon>keyboard_arrow_left</md-icon>
                        </md-button></div>
                    <div class="Cell"  v-for="(item,index) in monthDisplay" :key="index">{{Month[item.month]}} <span class="number-circle" :ref="`sum-${item.year}-${(item.month+1)}`">0</span>
                        <div class="Table">
                            <div class="Row">
                                <div class="Cell-Day" :ref="`d-${item.year}-${item.month+1}-${value}`" v-for="(value, index) in (1,item.date.daysInMonth())" :key=index></div>
                            </div>
                        </div>
                    </div>
                    <div class="Cell" style="width:60px;">
                        <md-button class="md-icon-button" @click="next()">
                            <md-icon>keyboard_arrow_right</md-icon>
                        </md-button>
                    </div>
                </div>

            </div>
        </div>

        <div class="toDay" ref="lineToDay"></div>

        <!-- <div class="grid">grid</div> -->
        <div class="events">
            <div class="event" v-for="(dat,index) in eventData" :key="index">
                 <div class="arrow-left"></div>
                <a class="item" :ref="`event-${index+1}`" style="display:none" @click="clickEvent(dat.id)">
                  
                  <span v-if="dat.title">{{dat.title}}<md-tooltip md-direction="top">{{dat.title}}</md-tooltip></span>
                  <span v-else>&nbsp;<md-tooltip md-direction="top">No title</md-tooltip></span>
                   
                </a>
                <div class="arrow-right"></div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment-timezone";
import { extendMoment } from "moment-range";

export default {
  name: "Calendar",
  props: {
    viewMonth: Number,
    eventData: {}
  },
  watch:{
      viewMonth(){
        this.renderMonth();
      }
  },
  data() {
    return {
      Month: [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC"
      ],
      toDay: moment(),
      thisMonth: moment(),
      //viewMonth: 3,
      monthDisplay: [],
      showToDay: ""
    };
  },
  mounted() {
    //if (this.viewMonth == null) this.viewMonth = 6;
    this.$nextTick(() => {
      window.addEventListener("resize", this.renderMonth);
      //window.addEventListener("resize", this.renderEvents);
      //console.log('render today render events')
    });
  },
  computed: {},
  created() {
    this.renderMonth();
  },
  methods: {
    renderToday() {
      // console.log("render to day");

      if (this.$refs["d-" + moment().format("YYYY-M-D")][0]) {
        let offsetLeft = this.$refs["d-" + moment().format("YYYY-M-D")][0]
          .offsetLeft;
        this.$refs["lineToDay"].style.display = "block";
        this.$refs["lineToDay"].style.left = offsetLeft + "px";
      } else {
        this.$refs["lineToDay"].style.display = "none";
      }
    },
    previous() {
      this.thisMonth = moment(this.thisMonth).add(-1, "M");
      this.renderMonth();
    },
    next() {
      this.thisMonth = moment(this.thisMonth).add(1, "M");
      this.renderMonth();
    },
    renderMonth() {
      // console.log("render month events");
      this.monthDisplay = [];
      let date = moment(this.thisMonth);
      for (let i = 0; i < this.viewMonth; i++) {
        this.monthDisplay.push({
          date: date,
          month: date.month(),
          year: date.year(),
          count: 0
        });

        date = moment(this.thisMonth).add(i + 1, "M");
      }

      setTimeout(() => {
        this.renderToday();
      }, 50);
      setTimeout(() => {
        this.renderEvents();
      }, 50);
    },
    renderEvents() {
      // console.log("render event");

      let firstMonth = this.monthDisplay[0].date
        .startOf("month")
        .format("YYYY-M-D");
      let lastMonth = this.monthDisplay[this.monthDisplay.length - 1].date
        .endOf("month")
        .format("YYYY-M-D");
      var summary = {};

      for (let i = 0; i < this.eventData.length; i++) {
        let offsetStart = 0;
        let offsetEnd = 0;
        let refsEvent = this.$refs["event-" + (i + 1)][0];

        switch (this.eventData[i].status) {
          case "Active":
            refsEvent.style.background = "#3B62C1";
            refsEvent.nextSibling.style.borderLeftColor = "#3B62C1";
            refsEvent.previousSibling.style.borderRightColor = "#3B62C1";
            break;
          case "Ready":
            refsEvent.style.background = "#52B6B0";
            refsEvent.nextSibling.style.borderLeftColor = "#52B6B0";
            refsEvent.previousSibling.style.borderRightColor = "#52B6B0";
            break;
          case "Pending":
            refsEvent.style.background = "#EBC26B";
            refsEvent.nextSibling.style.borderLeftColor = "#EBC26B";
            refsEvent.previousSibling.style.borderRightColor = "#EBC26B";
            break;
          case "Draft":
            refsEvent.style.background = "#A8A8A8";
            refsEvent.nextSibling.style.borderLeftColor = "#A8A8A8";
            refsEvent.previousSibling.style.borderRightColor = "#A8A8A8";
            break;
          case "Expired":
            refsEvent.style.background = "#E1E1E1";
            refsEvent.nextSibling.style.borderLeftColor = "#E1E1E1";
            refsEvent.previousSibling.style.borderRightColor = "#E1E1E1";
            break;          
          case "Reject":
            refsEvent.style.background = "#c13b82";
            refsEvent.nextSibling.style.borderLeftColor = "#c13b82";
            refsEvent.previousSibling.style.borderRightColor = "#c13b82";
            break;
        }

        let start = moment(this.eventData[i].start).format("YYYY-M-D");
        let end = moment(this.eventData[i].end).format("YYYY-M-D");

        if (new Date(end) < new Date(firstMonth)) {
          //console.log("end < first")
          refsEvent.style.display = "none";
          refsEvent.nextSibling.style.display = 'none';
          refsEvent.previousSibling.style.display = 'none';

        } else if (new Date(start) > new Date(lastMonth)) {
          //console.log("start > last")
          refsEvent.style.display = "none";
          refsEvent.nextSibling.style.display = 'none';
          refsEvent.previousSibling.style.display = 'none';
        } else if (new Date(start) >= new Date(firstMonth) && new Date(end) <= new Date(lastMonth)) {


          //console.log("start >= first && end <= last")

          offsetStart = this.$refs["d-" + start][0].offsetLeft;
          offsetEnd = this.$refs["d-" + end][0].offsetLeft - offsetStart;
          offsetEnd = offsetEnd + this.$refs["d-" + end][0].clientWidth;

          refsEvent.style.left = offsetStart + "px";
          refsEvent.style.display = "block";
          refsEvent.style.width = offsetEnd + "px";
          refsEvent.style.borderRadius = "3px";

          refsEvent.nextSibling.style.display = 'none';
          refsEvent.previousSibling.style.display = 'none';

        } else if (new Date(start) < new Date(firstMonth) && new Date(end) > new Date(lastMonth)) {
          
          //console.log("start < first && end > last")

          refsEvent.style.left = offsetStart + "px";
          refsEvent.style.display = "block";
          refsEvent.style.left = this.$refs["d-" + firstMonth][0].offsetLeft-60+"px";
          refsEvent.style.width =  this.$refs["d-" + lastMonth][0].offsetLeft - this.$refs["d-" + firstMonth][0].offsetLeft + this.$refs["d-" + lastMonth][0].clientWidth +12+'px';
          refsEvent.style.borderRadius = "0px";

          // refsEvent.nextSibling.style.display = 'block';
          // refsEvent.previousSibling.style.display = 'block';

        } else if (new Date(start) >= new Date(firstMonth) && new Date(start) <= new Date(lastMonth) && new Date(end) > new Date(lastMonth)) {

          //console.log("start >= first && start <= last && end > last")


          offsetStart = this.$refs["d-" + start][0].offsetLeft;
          refsEvent.style.left = offsetStart + "px";
          refsEvent.style.display = "block";
          refsEvent.style.width = this.$refs["d-" + lastMonth][0].offsetLeft - this.$refs["d-" + start][0].offsetLeft + this.$refs["d-" + lastMonth][0].clientWidth+ 61+'px';//"100%" - "60px";
          refsEvent.style.borderBottomLeftRadius = "3px";
          refsEvent.style.borderTopLeftRadius = "3px";
          refsEvent.style.borderBottomRightRadius = "0px";
          refsEvent.style.borderTopRightRadius = "0px";

          // refsEvent.nextSibling.style.display = 'block';
          // refsEvent.previousSibling.style.display = 'none';

        } else if (new Date(end) >= new Date(firstMonth) && new Date(end) <= new Date(lastMonth) && new Date(start) < new Date(firstMonth)) {
          
          offsetEnd = this.$refs["d-" + end][0].offsetLeft - 60;
          refsEvent.style.left = (this.$refs["d-" + firstMonth][0].offsetLeft-60)+"px";
          refsEvent.style.display = "block";
          refsEvent.style.width = offsetEnd +this.$refs["d-" + end][0].clientWidth+60+ "px";
          refsEvent.style.borderBottomRightRadius = "3px";
          refsEvent.style.borderTopRightRadius = "3px";
          refsEvent.style.borderBottomLeftRadius = "0px";
          refsEvent.style.borderTopLeftRadius = "0px";

          // refsEvent.nextSibling.style.display = 'none';
          // refsEvent.previousSibling.style.display = 'block';
        } else {
          // not render
        }

        for (let j = 0; j < this.monthDisplay.length; j++) {
          let firstDay = this.monthDisplay[j].date
            .startOf("month")
            .format("YYYY-M-D");
          let lastDay = this.monthDisplay[j].date
            .endOf("month")
            .format("YYYY-M-D");
          // console.log("start",start,"end",end);
          // console.log("first",firstDay,"last",lastDay)
          let year_month =
            this.monthDisplay[j].date.year() +
            "-" +
            (this.monthDisplay[j].date.month() + 1);

          if (new Date(start) >= new Date(firstDay) && new Date(end) <= new Date(lastDay)) {
            //console.log('in month', year_month)
            if (!("sum-" + year_month in summary))
              summary["sum-" + year_month] = 1;
            else
              summary["sum-" + year_month] = summary["sum-" + year_month] + 1;
          } else if (new Date(start) < new Date(firstDay) && new Date(end) > new Date(lastDay)) {
            //console.log('in month', year_month)
            if (!("sum-" + year_month in summary))
              summary["sum-" + year_month] = 1;
            else
              summary["sum-" + year_month] = summary["sum-" + year_month] + 1;
          } else if (new Date(start) >= new Date(firstDay) && new Date(start) <= new Date(lastDay) && new Date(end) > new Date(lastDay)
          ) {
            //console.log('in month', year_month)
            if (!("sum-" + year_month in summary))
              summary["sum-" + year_month] = 1;
            else
              summary["sum-" + year_month] = summary["sum-" + year_month] + 1;
          } else if (new Date(end) >= new Date(firstDay) && new Date(end) <= new Date(lastDay) && new Date(start) < new Date(firstDay)) {
            //console.log('in month', year_month)
            if (!("sum-" + year_month in summary))
              summary["sum-" + year_month] = 1;
            else
              summary["sum-" + year_month] = summary["sum-" + year_month] + 1;
          } else {
            if (!("sum-" + year_month in summary))
              summary["sum-" + year_month] = 0;
          }
        }
      }

      // count item in month
      var _self = this;
      Object.keys(summary).forEach(function(key) {
        _self.$refs[key][0].innerHTML = summary[key];
      });
    },
    goThisMonth() {
      this.thisMonth = moment();
      this.renderMonth();
    },
    rerender(){
      this.renderMonth();
    },
    clickEvent(event_id){
      // console.log(event_id);
      this.$emit('clickEvent', event_id)
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.renderMonth);
    window.removeEventListener("resize", this.renderEvents);

    //window.removeEventListener('resize', this.getWindowHeight);
  }
};
</script>

<style lang="scss">
/* button control */
.btn-this-month {
  padding-left: 10px;
  padding-right: 10px;
  background-color: rgb(140, 175, 255); /* Green */
  border: none;
  color: #fff;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 12px;
  height: 30px;
  border-radius: 3px;
  margin-right: 10px;
  cursor: pointer;
}
</style>